import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'ces-campaign-list-skeleton',
  standalone: true,
  imports: [SkeletonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './campaign-list.skeleton.component.html',
  styleUrl: './campaign-list.skeleton.component.scss',
})
export class CesCampaignListSkeletonComponent {
  @Input() cards = 5;
  @Input() lines = 10;
  @Input() gap = 1;

  get cardItems(): number[] {
    return Array.from({ length: this.cards }, (_, index) => index);
  }

  get lineItems(): number[] {
    return Array.from({ length: this.lines }, (_, index) => index);
  }

  getSkeletonOpacity(index: number): number {
    return 1 - index / Math.max(this.lines - 1, 1);
  }
}
